import { render, staticRenderFns } from "./PlatformSelection.vue?vue&type=template&id=6f259dad&scoped=true"
import script from "./PlatformSelection.vue?vue&type=script&lang=js"
export * from "./PlatformSelection.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelection.vue?vue&type=style&index=0&id=6f259dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f259dad",
  null
  
)

export default component.exports